import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { loginUser } from "../../store/reducers/authReducer";
import Loader from "../../components/Loader";
import Cookies from "js-cookie";
import { signupUser } from "../../store/reducers/signupSlice";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [helperText, setHelperText] = useState({
    email: "",
    password: "",
    gmailerror: "",
    loginerror: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    gmailerror: "",
    loginerror: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [loader, setLoader] = useState(false);
  const companyDetails = useSelector(
    (state) => state.companydetail.companyDetails
  );

  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const CLIENT_ID =
    "24660824558-kmbv1lh18n9e6urnqgrl32urhpql4in4.apps.googleusercontent.com";

  const GoogleLoginButton = () => {
    const login = useGoogleLogin({
      onSuccess: (tokenResponse) => {
        handleGoogleLogin(tokenResponse.access_token);
        setErrors((prevErrors) => ({
          ...prevErrors,
          gmailerror: "",
          email: "",
        }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          gmailerror: "",
          email: "",
        }));
      },
      onError: () => {
        console.error("Login Failed");
      },
    });

    return (
      <Button
        onClick={() => login()}
        variant="outlined"
        className="googleSignINbtn"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/google.png`}
          alt="Google Logo"
          style={{ height: 23 }}
        />
        <span>Login with Google</span>
      </Button>
    );
  };

  const handleGoogleLogin = async (token) => {
    console.log(token);
    setLoader(true);
    try {
      const loginData = {
        id_token: token,
      };
      const result = await dispatch(loginUser({ loginData })).unwrap();
      console.log("loginresponse:", result);
      const access = result?.access;
      const newRefresh = result?.refresh;

      Cookies.set("_d_token", access, {
        expires: 30,
        secure: true,
        sameSite: "Strict",
      });
      Cookies.set("_d_rtoken", newRefresh, {
        expires: 3000,
        secure: true,
        sameSite: "Strict",
      });
      navigate("/all-products");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Signup failed:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        gmailerror: error?.msg,
      }));
      setHelperText((prevHelperText) => ({
        ...prevHelperText,
        gmailerror: error?.msg,
      }));
    }
  };

  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = { email: "", password: "" };
    let newHelperText = { email: "", password: "" };
    let isValid = true;

    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
      newErrors.email = "Invalid email address";
      newHelperText.email = "Invalid email address";
      isValid = false;
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
      newHelperText.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setEmail(value);
      // Reset error if valid
      if (!validateEmail(value) && value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Invalid email address",
          loginerror: "",
          gmailerror: "",
        }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          email: "Invalid email address",
          loginerror: "",
          gmailerror: "",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "",
          loginerror: "",
          gmailerror: "",
        }));

        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          email: "",
          loginerror: "",
          gmailerror: "",
        }));
      }
    }
  };

  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true);
      const loginData = {
        username: email,
        password: password,
        company_name: companyDetails?.data?.company_username,
      };
      try {
        console.log(loginData);
        const result = await dispatch(loginUser({ loginData })).unwrap();
        console.log("login ressponse:", result);
        setLoader(false);
        if (result?.success) {
          var companyID = Cookies.get("_a_com");
          navigate(`/${companyID}/dashboard`);
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            loginerror: result?.msg,
          }));
          setHelperText((prevHelperText) => ({
            ...prevHelperText,
            loginerror: result?.msg,
          }));
        }
      } catch (error) {
        setLoader(false);
        console.error("login failed:", error);
        setErrors((prevErrors) => ({
          ...prevErrors,
          loginerror: error?.message,
        }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          loginerror: error?.message,
        }));
      }
    }
  };

  return (
    <>
      <HeaderApp type="login" />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          display: "flex",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
        }}
      >
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper
            elevation={3}
            sx={{
              padding: "1.6em 3em",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "#fffff",
              position: "relative",
              zIndex: 1,
              borderRadius: "15px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 700, fontSize: "24px" }}
            >
              Let’s get you in!
            </Typography>

            <GoogleOAuthProvider clientId={CLIENT_ID}>
              <GoogleLoginButton />
            </GoogleOAuthProvider>
            {errors.gmailerror && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto",
                }}
              >
                {helperText.gmailerror}
              </Typography>
            )}
            {errors.loginerror && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto",
                }}
              >
                {helperText.loginerror}
              </Typography>
            )}
            <Typography
              sx={{
                fontSize: "10px",
                color: "#7F7F7F",
                my: 2,
                textAlign: "center",
                fontWeight: "400",
              }}
            >
              This site is protected by reCAPTCHA and the{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#185CB7" }}
              >
                Google Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#185CB7" }}
              >
                Terms of Service
              </a>{" "}
              apply.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
      {loader && <Loader />}
    </>
  );
};

export default AdminLogin;
